import type { ReactNode } from 'react';
import { Button } from '@simplywallst/ui-core';

type Props = {
  isLoading?: boolean;
  value: boolean;
  onChange: (returnRecentCompaniesOnly: boolean) => void;
  children: ReactNode;
};

export const RecentResultsToggle = ({
  isLoading,
  value: returnRecentCompaniesOnly,
  onChange,
  children,
}: Props) => {
  return (
    <Button
      styleType={returnRecentCompaniesOnly ? 'loud' : 'gentle'}
      onClick={() => onChange(!returnRecentCompaniesOnly)}
      isLoading={isLoading}
      disabled={isLoading}
      aria-pressed={returnRecentCompaniesOnly}
    >
      {children}
    </Button>
  );
};
